module.exports = __webpack_public_path__ + "img/illus_setup_2@2x.a763d40d.png";